export var MediaImageStudioURL;
(function (MediaImageStudioURL) {
    MediaImageStudioURL["Prod"] = "https://manage.wix.com/media-image-studio";
    MediaImageStudioURL["ProdEditorX"] = "https://manage.editorx.com/media-image-studio";
    MediaImageStudioURL["Local"] = "https://local.wix.com:3010";
})(MediaImageStudioURL || (MediaImageStudioURL = {}));
//# sourceMappingURL=urls.js.map